import React from 'react';
import { Field } from './Dialog';
import { ACTIVITY_TYPES, CUSTOM_TYPE_LIMIT } from '../utils/labNaming';

/** The same controlled type/number inputs for creating and renaming a lab. */
export default function LabNamingFields({ value, onChange, idPrefix = 'lab', disabled = false }) {
  const change = (key, next) => onChange({ ...value, [key]: next });
  const typeLabel = value.activityType === 'custom' ? 'Activity' : ACTIVITY_TYPES[value.activityType] || 'Activity';
  return (
    <>
      <div className="form-grid form-grid-21">
        <Field label="Activity Type" htmlFor={`${idPrefix}-activity-type`} required>
          <select id={`${idPrefix}-activity-type`} value={value.activityType} disabled={disabled}
            onChange={e => change('activityType', e.target.value)} required>
            {!value.activityType && <option value="" disabled>Choose a type…</option>}
            {Object.entries(ACTIVITY_TYPES).map(([key, label]) => <option key={key} value={key}>{label}</option>)}
          </select>
        </Field>
        <Field label={`${typeLabel} Number`} htmlFor={`${idPrefix}-number`} required>
          <input id={`${idPrefix}-number`} type="number" min="1" step="1" max={Number.MAX_SAFE_INTEGER}
            value={value.activityNumber} disabled={disabled} required
            onChange={e => change('activityNumber', e.target.value)} />
        </Field>
      </div>
      {value.activityType === 'custom' && (
        <Field label="Custom Type" htmlFor={`${idPrefix}-custom-type`} required
          hint="Type only, for example Assignment or Practical Exam. Choose the number above.">
          <input id={`${idPrefix}-custom-type`} value={value.customActivityType} disabled={disabled}
            onChange={e => change('customActivityType', e.target.value)} required maxLength={CUSTOM_TYPE_LIMIT}
            placeholder="Practical Exam" />
        </Field>
      )}
    </>
  );
}
